import { createAction } from '@reduxjs/toolkit';
export const ADD_CALL_SESSION = 'ADD_CALL_SESSION';
export const addCallSessionAction = createAction(ADD_CALL_SESSION);